import { MenuIdProjects } from '@jira/navigation-apps__constants/src/MenuIdProjects.tsx';
import { SidebarIdProjectSettings } from '@jira/navigation-apps__constants/src/SidebarIdProjectSettings.tsx';
import { corePolicyConflictsPageEntryPoint } from '@jira/spa-apps__guided-autonomy-remediation/src/corePolicyConflictsPageEntryPoint.entrypoint.tsx';
// eslint-disable-next-line jira/import/no-restricted-import
import { getBusinessProjectResources } from '@jira/router-resources__business-common/src/getBusinessProjectResources.tsx';
// eslint-disable-next-line jira/import/no-restricted-import
import { licenseDetailsResource_DEPRECATED_DO_NOT_USE } from '@jira/router-resources__business-license-details/src/useIsPremiumUserSeat.tsx';
import { forgeProjectModuleResource } from '@jira/navigation-apps__resources/src/controllers/forge/index.tsx';
import { staticProjectSidebarConnectAddonsNavigationResource } from '@jira/navigation-apps__resources/src/controllers/sidebar/static-project-sidebar-connect-addons/index.tsx';
import { staticProjectSidebarNavigationResource } from '@jira/navigation-apps__resources/src/controllers/sidebar/static-project-sidebar/index.tsx';
import { createPageEntryPoint } from '@jira/platform__routing-create-route-entry-point/src/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { coreProjectLayout } from '@jira/platform__layouts-core-project-layout/src/index.tsx';
import { getNavigationResources } from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { notFoundPageEntrypoint } from '@jira/router-routes__not-found-entrypoint/src/ui/error-pages/not-found/index.tsx';
import { projectSettingsCorePolicyConflictsRoute } from '@jira/router-routes__project-settings-core-routes/src/projectSettingsCorePolicyConflictsRoute.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import type { Route } from '@atlassian/react-resource-router';
import { getNavigationSidebarProjectSettingsResource } from './common/getNavigationSidebarProjectSettingsResource.tsx';

const corePolicyConflictsPage = createPageEntryPoint({
	main: corePolicyConflictsPageEntryPoint,
});

export const projectSettingsCorePolicyConflictsRouteEntry: Route = createEntry(
	projectSettingsCorePolicyConflictsRoute,
	() => ({
		group: 'project-settings-core',
		ufoName: 'project-settings.policy-conflicts.jwm',
		layout: coreProjectLayout,
		navigation: {
			menuId: MenuIdProjects,
			sidebarId: SidebarIdProjectSettings,
		},
		resources: [
			...getNavigationResources(),
			forgeProjectModuleResource,
			staticProjectSidebarNavigationResource,
			staticProjectSidebarConnectAddonsNavigationResource,
			...getNavigationSidebarProjectSettingsResource(),
			...getBusinessProjectResources(),
			licenseDetailsResource_DEPRECATED_DO_NOT_USE,
		],
		entryPoint: () =>
			fg('guided_autonomy_remediation') ? corePolicyConflictsPage : notFoundPageEntrypoint,
		meta: {
			reporting: {
				id: 'project-settings.policy-conflicts.jwm',
				packageName: 'jiraSpaAppsGuidedAutonomyRemediation',
				teamName: 'a4t-tanuki',
			},
		},
		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
